export default __webpack_public_path__ + "static/media/file-upload-placeholder.ed58151a.png";